import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { take, map } from 'rxjs/operators';
@Injectable({
   providedIn: 'root',
 })
 export class CheckLoginGuard implements CanActivate {
   constructor(private authService: AuthService, private router: Router) {}

   canActivate() {
     if (this.authService.isLogged()) {
       return true;
     } else {
       this.router.navigate(['/']);
       return false;
     }
   }

}
